// @flow
import {schema} from 'normalizr'

export const accountManagersSchema = new schema.Entity('records')
export const companiesSchema = new schema.Entity('records')
